<template>
	<svg
		width="26"
		height="26"
		viewBox="0 0 26 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.49306 2.47919C9.65984 2.4236 9.84016 2.4236 10.0069 2.47919L16.25 4.56022L21.6375 2.76439C21.6375 2.76439 21.6376 2.76438 21.6376 2.76438C22.5846 2.44869 23.5625 3.15364 23.5625 4.15183V20.1148C23.5625 20.7444 23.1596 21.3032 22.5625 21.5023L22.5624 21.5023L16.5069 23.5208C16.3402 23.5764 16.1598 23.5764 15.9931 23.5208L9.75 21.4398L4.36249 23.2357L4.36247 23.2357C3.41538 23.5514 2.4375 22.8463 2.4375 21.8481V5.88516C2.4375 5.25568 2.8403 4.69678 3.43751 4.49772C3.43752 4.49771 3.43753 4.49771 3.43753 4.49771L9.49306 2.47919ZM10.5625 19.9977L15.4375 21.6227V6.00228L10.5625 4.37728V19.9977ZM8.9375 4.37728V19.9977L4.0625 21.6228V6.00229L8.9375 4.37728ZM3.95138 6.03933L3.95154 6.03927L3.95138 6.03933ZM17.0625 6.00229V21.6227L21.9375 19.9978V4.3773L17.0625 6.00229Z"
			fill="white"
		/>
	</svg>
</template>
